import { CreditCardStoreService } from '@hb/modules/financial-obligations/credit-card/credit-card-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { ExtraInformationComponent } from '@hb/modules/global/tip/extra-information.component';
import { NextButtonComponent } from '@hb/modules';

import { Component, inject } from '@angular/core';

import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'credit-card-tip',
    imports: [ExtraInformationComponent, NextButtonComponent, ApContentPipe],
    templateUrl: './credit-card-tip.component.html'
})
export class CreditCardTipComponent {
    protected readonly store = inject(CreditCardStoreService);
    protected readonly questionKey = QuestionKey.CREDIT_CARD_TIP;

    nextQuestion(): void {
        this.store.setCreditCardTipFinished();
    }
}
